import { getAutocompleteData } from '../services/autocompleteAPI.js';
import { addAutocompleteMenuToDOM, closeAllLists } from './manipulateDOM.js';

let currentFocus = null;

// One time function that sets up listeners
function autocomplete(
  inputElement,
  categoryElement,
  autocompleteEndpoint,
  autocompleteLimit,
  librarySearchFunc
) {
  let timeout = null;
  const userPauseTime = 120;

  // When a user types
  inputElement.addEventListener('input', function (e) {
    clearTimeout(timeout);
    const val = this.value;
    closeAllLists(inputElement);
    if (!val) {
      return false;
    }

    // Only send a request to the server when the user pauses in their typing
    timeout = setTimeout(function () {
      currentFocus = -1;
      getAutocompleteData(
        inputElement.value,
        categoryElement,
        autocompleteEndpoint,
        autocompleteLimit
      )
        .then(function (result) {
          return addAutocompleteMenuToDOM(inputElement, val, librarySearchFunc, result);
        })
        .catch(function (error) {
          console.error(error);
        });
    }, userPauseTime);
  });

  // User can interact with autocomplete options using arrow and enter keys
  inputElement.addEventListener('keydown', function (e) {
    let autocompleteList = document.getElementById(`${this.id}autocomplete-list`);
    if (autocompleteList) {
      autocompleteList = autocompleteList.getElementsByTagName('div');
    }
    if (e.keyCode === 40) {
      // "Down" goes down the list of options
      currentFocus++;
      addActive(autocompleteList);
    } else if (e.keyCode === 38) {
      // "Up" goes up the list of options
      currentFocus--;
      addActive(autocompleteList);
    } else if (e.keyCode === 13) {
      // Enter key pulls from autocomplete menu if selected, then searches
      if (currentFocus > -1) {
        // Autocomplete item being selected, delays search until after selection
        e.preventDefault();
        if (autocompleteList) {
          autocompleteList[currentFocus].click();
          currentFocus = -1;
        }
      } else {
        // Default behavior searches
        closeAllLists(inputElement);
      }
    }
  });
  // Close out of the autocomplete menu when a user clicks in the document
  document.addEventListener('click', function (e) {
    closeAllLists(inputElement, e.target);
  });
}

// Sets an autocomplete option to active
function addActive(element) {
  if (!element) {
    return false;
  }
  removeActive(element);
  if (currentFocus >= element.length) {
    currentFocus = 0;
  }
  if (currentFocus < 0) {
    currentFocus = element.length - 1;
  }
  element[currentFocus].id = 'library-autocomplete-active';
}

// Deactivates all autocomplete options
function removeActive(element) {
  for (let i = 0; i < element.length; i++) {
    element[i].removeAttribute('id');
  }
}

export { autocomplete as default };
